<div class="secure-url-input-container">
  <app-input-text
    [bare]="true"
    [plain]="true"
    [inputId]="id"
    [value]="shouldShowPlaceholder ? '' : value"
    [placeholder]="placeholder"
    [maxLength]="maxLength"
    [isDisabled]="disabled"
    [autocomplete]="autocomplete"
    [cssClass]="cssClass"
    [isInvalid]="isInvalid"
    (inputEvent)="onInput($event)"
    (focusEvent)="onFocus($event)"
    (blurEvent)="onBlur($any($event))"
  ></app-input-text>

  <!-- Error message -->
  <div
    *ngIf="isInvalid"
    [id]="id + '-error'"
    class="invalid-feedback"
    role="alert"
    aria-live="polite"
  >
    {{ errorMessage }}
  </div>
</div>
